// node_modules
import axios from "axios";
// Helpers
import { AxiosHelperSingleton } from "Helpers";
// Types
import { TUserDTO } from "Types";

export class UserController {
    public async logoutAsync(): Promise<void> {
        await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}Account/Logout`);
    }

    public async caseSearchAsync(caseId: number, query: string): Promise<TUserDTO[]> {
        const result = await axios.get<TUserDTO[]>(`${AxiosHelperSingleton.getServerBaseURL()}api/users/case/${caseId}/search?query=${query}`);
        return result.data;
    }

    public async addUserToCaseAsync(caseId: number, userId: string): Promise<boolean> {
        const formData = new FormData();
        formData.append("userId", userId);
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/users/addTo/case/${caseId}`, formData);
        return result.status === 200;
    }

    public async removeUserFromCaseAsync(caseId: number, userId: string): Promise<boolean> {
        const formData = new FormData();
        formData.append("userId", userId);
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/users/removeFrom/case/${caseId}`, formData);
        return result.status === 200;
    }
    
    public async getCurrentAsync(): Promise<TUserDTO> {
        return (await axios.get<TUserDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/users/getcurrent`)).data;
    }
}

export const UserControllerSingleton = new UserController();